import { GapsTab } from '@/features/ai/GapsTab';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/ai/gaps')({
  validateSearch: z.object({ status: z.string().optional(), topic: z.string().optional() }),
  component: GapsTab,
});
